import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './peek-password.magic.css.js';
import PeekPasswordComponent from './peek-password.js';

const __vue_script__ = PeekPasswordComponent;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "peek-password",
      attrs: {
        part: "peek-password",
        "data-v-test-id": _vm.$attrs["data-v-test-id"] + "-div"
      }
    },
    [
      _c(
        _vm.muggle ? "ui-form-field" : "magic-ui-form-field",
        _vm._b(
          {
            tag: "component",
            attrs: {
              autocorrect: "off",
              autocapitalize: "off",
              spellcheck: "false",
              icon: "",
              "no-icon": "",
              focused: _vm.focused,
              type: _vm.isShown ? "text" : "password"
            },
            on: {
              keypress: function($event) {
                _vm.unmaskPassword && _vm.maskPassword(true);
              },
              blur: function($event) {
                _vm.unmaskPassword && _vm.isShown && _vm.maskPassword(false);
              }
            }
          },
          "component",
          _vm.$filteredAttrs,
          false
        )
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "toggle",
          attrs: {
            type: "button",
            part: "toggle",
            "data-v-test-id": "eye-password",
            "aria-label": _vm.isShown ? "⦿" : "⦾"
          },
          on: { click: _vm.togglePassword }
        },
        [
          _vm.isShown
            ? _c("magic-ui-icon", {
                staticClass: "icon",
                attrs: {
                  name: "eye-solid",
                  part: "icon",
                  "data-v-test-id": "eye-icon"
                }
              })
            : _c("magic-ui-icon", {
                staticClass: "icon",
                attrs: {
                  name: "eye",
                  part: "icon",
                  "data-v-test-id": "eye-icon"
                }
              })
        ],
        1
      )
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-1ba369c4_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-1ba369c4";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
